export default class Reset {
  constructor (token, password, confirm) {
    this.token = token
    this.password = password
    this.confirm = confirm
  }
}
